import { Component, OnInit, Input } from '@angular/core';
import { CaseService } from '../../../../shared/services/case.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-case-overview-item',
  templateUrl: './add-case-overview-item.component.html',
  styleUrls: ['./add-case-overview-item.component.scss']
})
export class AddCaseOverviewItemComponent implements OnInit {

  @Input() caseId: number;
  isLoading: boolean = false;

  form = new UntypedFormGroup({
    text: new UntypedFormControl()
  });

  constructor(private caseService: CaseService,
    public activeModal: NgbActiveModal
  ) {

  }

  ngOnInit(): void {
  }

  addItem(){

    this.isLoading = true;

    this.caseService.addCaseOverviewItem(this.caseId, this.form.value).subscribe((response : any) => {

      this.activeModal.close(true);

      this.isLoading = false;

      }, (error : any) => {

        var errorMessage = "Failed to add item";
        /*
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }*/

      });
  }

  cancel(){
    this.activeModal.dismiss();
  }

}
